import angular from 'angular';
import config from 'app/config';

import countdown from './countdown/countdown.component';
import mlrcta from './cta/cta.component';
import mlrfooter from './footer/footer.component';
import mlrmodal from './modal/modal.component';
import opform from './opform/opform.component';
import mlrvideo from './video/video.component';

export default angular
  .module(`${config.appName}.commonComponents`, [
    mlrcta,
    countdown,
    mlrvideo,
    mlrmodal,
    opform,
    mlrfooter
  ])
  .name;